import React from 'react';
import BaseModal, { BaseModalProps } from '../../../BaseModule/Components/BaseModal/BaseModal';
import UserWalletDeposit from './UserWalletDeposit';

interface Props extends BaseModalProps {}

const UserWalletDepositModal: React.FC<Props> = (props) => <BaseModal {...props} title='component.userWalletDeposit.modalTitle'><UserWalletDeposit /></BaseModal>
export default UserWalletDepositModal;

